import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import InfiniteLoading from 'vue-infinite-loading';
// import PerfectScrollbar from 'vue2-perfect-scrollbar';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css';

// vue markdown 套件
// import VMdEditor from '@kangc/v-md-editor';
// import '@kangc/v-md-editor/lib/style/base-editor.css';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';
VMdPreview.use(vuepressTheme, { Prism });
// import zhTW from '@kangc/v-md-editor/lib/lang/zh-TW';

import dayjs from 'dayjs' // 1. 引入 dayjs 主體
import relativeTime from 'dayjs/plugin/relativeTime' // 2. 引入 relativeTime 插件
import customParseFormat from "dayjs/plugin/customParseFormat";
import 'dayjs/locale/zh-tw' // 3. 引入繁體中文語系
dayjs.extend(relativeTime) // 4. 註冊插件
dayjs.extend(customParseFormat) // 4. 註冊插件
dayjs.locale('zh-tw') // 5. 設定預設語系為繁體中文

import { mapActions, mapMutations, mapGetters } from 'vuex';

// VMdEditor.lang.use('en-US', zhTW);
VMdPreview.use(vuepressTheme, {
  Prism,
});
Vue.use(VMdPreview);
// Vue.use(VMdEditor);

// Google reCaptcha
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true, // 可選，如果 Google.com 被封鎖，使用 recaptcha.net
    autoHideBadge: true, // 可選，是否自動隱藏右下角的 reCAPTCHA 標誌（注意：若隱藏需自行顯示 reCAPTCHA 服務條款）
  },
});

Vue.filter('timeAgo', (value) => {
  if (!value) return ''
  return dayjs(value).fromNow()
})

Vue.use(VueAxios, axios);
Vue.use(router);
Vue.use(store);
Vue.use(vuetify);
// Vue.use(OneSignalVue);
// Vue.use(PerfectScrollbar);
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'circles',
  },
  system: {
    throttleLimit: 50,
  },
});

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-multi-assign
  Vue.config.devtools = Vue.config.debug = Vue.config.productionTip = false;
} else {
  // eslint-disable-next-line no-multi-assign
  Vue.config.devtools = Vue.config.debug = Vue.config.productionTip = true;
}

// 全域function
Vue.prototype.$getAge = function(birthDay) {
  let today = new Date();
  let birthDate = new Date(birthDay);
  let age = today.getFullYear() - birthDate.getFullYear();
  let hasGetOld = (today.getMonth() + 1) * 30 + today.getDate() > (birthDate.getMonth() + 1) * 30 + birthDate.getDate();
  if(!hasGetOld) {
    if(today.getDate() !== birthDate.getDate()) {
      age = age - 1;
    }
  }
  return age;
};

Vue.mixin({
  data() {
    return {
      filterTagList: ["財經", "科技", "醫療", "自然", "居家", "社會", "體育"],
      STATIC_URL: process.env.NODE_ENV === 'production' ? `${process.env.VUE_APP_GOOGLE_STORAGE_BUCKET}static/` : '/',
      SERVER_STATIC_URL: process.env.VUE_APP_GOOGLE_STORAGE_BUCKET,

      SERVER_DOMAIN: process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BACKEND,
      WS_HEAD: process.env.npm_config_mode === 'test' ? 'ws' : 'wss',
      WS_DOMAIN: process.env.VUE_APP_BACKEND,
      NODE_DOMAIN: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BACKEND : '//127.0.0.1:3000',
      OVERLAY_OPACITY: '0.95',
      LINE_LOGIN_ID: process.env.VUE_APP_LINE_ID,
      LINE_LOGIN_DOMAIN: process.env.NODE_ENV === 'production' ? 'https://insight.cancell.ai' : 'http://127.0.0.1:3000',
    }
  },
  methods: {
    // avatarSrcLink(url) {
    //   if (url.includes('http:/') || url.includes('https:/')) {
    //     console.log('Line ThumbSrc');
    //     return url;
    //   }
    //   return `${this.SERVER_STATIC_URL}media/${url}`;
    // },
    routerPathChange(path) {
      this.$router.push(path).catch(() => true);
    },

    ...mapActions({
      apiUserLogin: 'global/login',
      apiUserRegister: 'global/userRegister',
      apiUserOrderHistory: 'global/userOrderHistory',
      apiUserProfileControl: 'global/userProfileControl',
      apiUserSendMessage: 'global/userSendMessage',
      apiUserUpdateMessagePositive: 'global/userUpdateMessagePositive',
      apiUserUpdateMessageSupport: 'global/userUpdateMessageSupport',
      apiUserChatMessage: 'global/userChatMessage',
      apiUserClone: 'global/userClone',
      apiUserCloneLoad: 'global/userCloneLoad',
      apiUserNotify: 'global/userNotify',
      apiUserNotifyRead: 'global/userNotifyRead',
      apiUserChatRoom: 'global/userChatRoom',
      apiUserCreateClone: 'global/userCreateClone',
      apiUserJoinParticipant: 'global/userJoinParticipant',
      apiUserAgreeParticipant: 'global/userAgreeParticipant',
      apiUserRejectParticipant: 'global/userRejectParticipant',
      apiChatRoomInitial: 'global/userChatRoomInitial',
      apiQrCodeGenerate: 'global/qrcodeGenerate',
      apiLineAuthorize: 'global/lineAuthorize',
      apiEcpayCreateOrder: 'global/ecpayCreateOrder',
      apiSearchTagRelated: 'global/searchTagRelated',
      apiGetModels: 'global/getModels',
      apiGetModelsDetail: 'global/getModelsDetail',
    }),

    ...mapMutations({
      mutateLogin: 'global/MUTATE_LOGIN',
      mutateLogout: 'global/CLEAR_AUTH_DATA',
      mutateProfile: 'global/MUTATE_PROFILE',
      mutateNewsDialog: 'global/MUTATE_NEWS_DIALOG',
      mutatePlanDialog: 'global/MUTATE_PLAN_DIALOG',
      mutateCloneDialog: 'global/MUTATE_CLONE_DIALOG',
      mutateQrCodeDialog: 'global/MUTATE_QR_CODE_DIALOG',
      mutateProfileDialog: 'global/MUTATE_PROFILE_DIALOG',
      mutateSnackBar: 'global/MUTATE_SNACKBAR',
      updateMsgBox: 'global/UPDATE_MESSAGE_BOX',
    }),
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      getNewsDialog: 'global/exportNewsDialog',
      getPlanDialog: 'global/exportPlanDialog',
      getCloneDialog: 'global/exportCloneDialog',
      getQrCodeDialog: 'global/exportQrCodeDialog',
      getProfileDialog: 'global/exportProfileDialog',
      getSnackBar: 'global/exportSnackBar',
      getLogin: 'global/exportLogin',
      getUserId: 'global/exportUserId',
      getProfile: 'global/exportProfile',
      msgBox: 'global/exportMessageBox',
      rwdType: 'global/exportRwdType',
    }),
  },
});

store.dispatch('global/tryAutoLogin').then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
});

// const vm = new Vue({
//   store,
//   router,
//   vuetify,
//   render: (h) => h(App),
// }).$mount('#app');

// (() => vm)();